export default __webpack_public_path__ + "static/media/help-banner.f8245f13.png";